export enum SystemRole {
  None = 0,
  PlatformOwner = 1,
  OrganizationOwner = 2,
  Admin = 3,
  Manager = 4,
  Receptionist = 5,
  Staff = 6,
}

export interface User {
  id: string;
  email: string;
  userName: string;
  contact: string;
  isEmailVerified: boolean;
  isMfaEnabled: boolean;
  isActive: boolean;
  systemRole: SystemRole;
  passwordHash?: string | null;
  createdAt?: string;
  emailVerificationToken?: string | null;
  emailVerificationTokenExpiry?: string | null;
  passwordResetToken?: string | null;
  passwordResetTokenExpiryAt?: string | null;
  mfaSecretKey?: string | null;
  userOrganizationId?: string | null;
  roleName?: string | null;
  order?: number | null;
  designation?: string | null;
  qualification?: string | null;
  bio?: string | null;
  profilePictureUrl?: string | null;
  isPublic?: boolean;
}